import { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { Button } from '@repo/ui/src/components/ui/button';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@repo/ui/src/components/ui/alert-dialog';
import { useResetDemoOrg } from '../../hooks/useAdminDemo';

interface ResetDemoOrgButtonProps {
  slug: string;
  orgName: string;
}

/** THI-257 — only rendered by `OrgDetailPage` when `GET /admin/demo` says
 *  enabled and this org's slug is one of the demo orgs. Confirm → run →
 *  toast, mirroring `SuspendOrgButton`'s dialog shape. */
export function ResetDemoOrgButton({ slug, orgName }: ResetDemoOrgButtonProps) {
  const [open, setOpen] = useState(false);
  const resetDemo = useResetDemoOrg(slug, orgName);

  return (
    <>
      <Button type="button" variant="destructive" onClick={() => setOpen(true)} disabled={resetDemo.isPending}>
        {resetDemo.isPending ? (
          <>
            <Loader2 className="h-4 w-4 animate-spin" /> Đang reset...
          </>
        ) : (
          'Reset dữ liệu mẫu'
        )}
      </Button>

      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Reset dữ liệu mẫu</AlertDialogTitle>
            <AlertDialogDescription>
              Xoá toàn bộ dữ liệu của {orgName} và dàn lại từ đầu như mới. Liên kết ngân hàng được
              giữ. Nếu khách trước đã tự gắn tài khoản của họ, tài khoản đó cũng được giữ nguyên,
              hãy gỡ tay trước khi giao cho khách kế tiếp. Mất khoảng một phút.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel disabled={resetDemo.isPending}>Huỷ</AlertDialogCancel>
            <AlertDialogAction
              onClick={() => {
                resetDemo.mutate(undefined, { onSuccess: () => setOpen(false) });
              }}
              disabled={resetDemo.isPending}
              className="bg-red-600 hover:bg-red-700"
            >
              Reset dữ liệu mẫu
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
